var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1764 14.2379C14.1764 15.1043 13.4755 15.8131 12.6013 15.8131H3.93789L5.51305 14.2379H12.6013V9.56785H14.1764V14.2379Z",
    fill: "#1744E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30371 1.63669V3.21184H1.57516V11.0876L0 12.6628V3.21184C7.57375e-08 2.34551 0.708821 1.63669 1.57516 1.63669H6.30371Z",
    fill: "#1744E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5703 7.4297H14.4248V1.57516H8.5703V7.4297ZM16 8.21728L15.9962 8.29803C15.9557 8.69508 15.6201 9.00486 15.2124 9.00486H7.78272C7.34776 9.00486 6.99514 8.65224 6.99514 8.21728V0.787579C6.99514 0.379868 7.30492 0.0442733 7.70197 0.0038456L7.78272 0H15.2124L15.2932 0.0038456C15.6902 0.0442734 16 0.379868 16 0.787579V8.21728Z",
    fill: "#1744E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2882 9.65183C6.40532 9.62045 6.51263 9.72776 6.48125 9.84488L5.6429 12.9737C5.61146 13.0905 5.4656 13.1298 5.37987 13.0444L4.79072 12.4553L2.0165 15.2303C1.95507 15.2916 1.85572 15.2915 1.79423 15.2303L0.902819 14.3388C0.841459 14.2774 0.841461 14.1781 0.902819 14.1166L3.67703 11.3416L3.08943 10.754C3.00369 10.6682 3.04306 10.5216 3.16019 10.4902L6.2882 9.65183Z",
    fill: "#1744E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopup);
export default __webpack_public_path__ + "static/media/popup.c34587fe14d01a27e46265c9e1bb2e1d.svg";
export { ForwardRef as ReactComponent };